module.exports = __webpack_public_path__ + "static/img/cont62 (1).6f850a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont62 (1).jpg
// module id = 3ugE
// module chunks = 0